import React from "react";
import { useDispatch } from "react-redux";
import { onValue, ref } from "firebase/database";
import { database } from "../firebaseConfig";
import { setLoading } from "../redux/slices/ui";
import { setSuplliers } from "../redux/slices/supplier";
import AddSupplier from "../components/suppliers/AddSupplier";
import ModalAddSupplier from "../components/suppliers/ModalAddSupplier";
import ModalEditSupplier from "../components/suppliers/ModalEditSupplier";
import List from "../components/suppliers/List";
import PageHeader from "../components/ui/PageHeader";

const Suppliers = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setLoading(true));
    const suppliersRef = ref(database, "suppliers");
    onValue(suppliersRef, (snapshot) => {
      dispatch(setSuplliers(snapshot.val() ?? {}));
      dispatch(setLoading(false));
    });
  }, []);

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <PageHeader title="Προμηθευτές" />
      <div className="flex-1 overflow-y-auto px-4 pb-24">
        <List />
      </div>
      <AddSupplier />
      <ModalAddSupplier />
      <ModalEditSupplier />
    </div>
  );
};

export default Suppliers;
